import { useDisclosure } from '@nextui-org/react'
import { FC } from 'react'
import { usePatchUpdate } from '../../hooks/usePatchUpdate'
import useHomeUpdateStore from '../../store/home/useHomeUpdateStore'
import { CommonAlert } from '../common/Alert'
import { BaseModalFooter } from '../common/Modal'

type InitialInfoButtonProps = {
  onClose: () => void
  isBack: () => void
}
export const InitialInfoButton: FC<InitialInfoButtonProps> = ({ onClose, isBack }) => {
  const { isOpen: isOpenAlert, onOpen: onOpenAlert, onClose: onCloseAlert } = useDisclosure()
  const { beEmptyTanks, updateDate, updateData, typeError, requiredError, checkRequired } =
    useHomeUpdateStore()

  const patchUpdateMutation = usePatchUpdate()

  const chekTanksValuesBeforeFinish = () => {
    checkRequired()
    if (!typeError && !requiredError) {
      if (beEmptyTanks.length !== 0) {
        onOpenAlert()
      } else {
        finishJob(onClose)
      }
    }
  }

  const finishJob = (onCloseModal: () => void, _onOpen?: () => void) => {
    if (updateDate && updateData.length !== 0) {
      patchUpdateMutation.mutate(
        {
          updateDate,
          updateForm: updateData,
          schoolIds: updateData.map((item) => item.schoolId),
        },
        {
          onSuccess: () => {
            onCloseModal()
          },
        },
      )
    }
  }
  return (
    <>
      <BaseModalFooter
        back="Back"
        next="Finish"
        backOnPress={() => {
          onClose()
          isBack()
        }}
        nextOnPress={chekTanksValuesBeforeFinish}
      />
      <CommonAlert
        isOpenAlert={isOpenAlert}
        onCloseAlert={onCloseAlert}
        continueJob={(_, __) => finishJob(onClose, undefined)}
        title="Some tanks will be empty"
      >
        {beEmptyTanks.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </CommonAlert>
    </>
  )
}
